interface ILogo {
  isLight?: boolean;
}
const BMFLogo = ({ isLight = true }: ILogo) => {
  // const BMFColor = isLight ? "" : "#fff";
  return (
    <svg
      width="140"
      height="39"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 140 39"
    >
      <defs>
        <style>
          {
            "\n      .cls-1 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: #ea2727;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#New_Gradient_Swatch_2-2);\n      }\n\n      .cls-27 {\n        isolation: isolate;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-11 {\n        fill: url(#New_Gradient_Swatch_2);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-20, .cls-28 {\n        mix-blend-mode: screen;\n        opacity: .25;\n      }\n\n      .cls-21 {\n        fill: #838383;\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-23 {\n        fill: #204181;\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-26 {\n        fill: #184a80;\n      }\n    "
          }
        </style>
        <linearGradient
          id="linear-gradient"
          x1={-464.16}
          y1={-51.35}
          x2={-464.16}
          y2={-65.4}
          gradientTransform="translate(547.72 71.88)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#0e1d41" />
          <stop offset={0.22} stopColor="#0c305b" />
          <stop offset={0.75} stopColor="#085c97" />
          <stop offset={1} stopColor="#076eaf" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1={-456.04}
          y1={-57.54}
          x2={-456.04}
          y2={-62.85}
          gradientTransform="translate(547.72 71.88)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.04} stopColor="#f1f1f1" />
          <stop offset={0.11} stopColor="#cecece" />
          <stop offset={0.21} stopColor="#969696" />
          <stop offset={0.33} stopColor="#494949" />
          <stop offset={0.44} stopColor="#010101" />
          <stop offset={1} stopColor="#010101" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1={-460.34}
          y1={-57.52}
          x2={-460.34}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-4"
          x1={-427.78}
          y1={-59.27}
          x2={-427.78}
          y2={-63.04}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-5"
          x1={-416.95}
          y1={-61.44}
          x2={-416.95}
          y2={-63.61}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-6"
          x1={-441.64}
          y1={-58}
          x2={-441.64}
          y2={-63.05}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-7"
          x1={-434.44}
          y1={-58.68}
          x2={-434.44}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-8"
          x1={-449.35}
          y1={-57.65}
          x2={-449.35}
          y2={-65.33}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-9"
          x1={-421.74}
          y1={-60.75}
          x2={-421.74}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-10"
          x1={-478.82}
          y1={-57.88}
          x2={-478.82}
          y2={-65.33}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-11"
          x1={-495.9}
          y1={-59.14}
          x2={-495.9}
          y2={-63.05}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-12"
          x1={-505.32}
          y1={-60.61}
          x2={-505.32}
          y2={-65.33}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-13"
          x1={-465.86}
          y1={-57.51}
          x2={-465.86}
          y2={-65.37}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-14"
          x1={-471.52}
          y1={-57.58}
          x2={-471.52}
          y2={-65.37}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-15"
          x1={-487.49}
          y1={-58.31}
          x2={-487.49}
          y2={-63.05}
          xlinkHref="#linear-gradient-2"
        />
        <linearGradient
          id="New_Gradient_Swatch_2"
          data-name="New Gradient Swatch 2"
          x1={-462.34}
          y1={-54.25}
          x2={-462.34}
          y2={-65.37}
          gradientTransform="translate(547.72 71.88)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#424242" />
          <stop offset={1} stopColor="#5a5a5c" />
        </linearGradient>
        <linearGradient
          id="New_Gradient_Swatch_2-2"
          data-name="New Gradient Swatch 2"
          x1={-528.39}
          y1={-50.16}
          x2={-528.39}
          y2={-68.86}
          xlinkHref="#New_Gradient_Swatch_2"
        />
        <linearGradient
          id="linear-gradient-16"
          x1={-537.8}
          y1={-55.96}
          x2={-524.86}
          y2={-68.89}
          gradientTransform="translate(547.72 71.88)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f28021" />
          <stop offset={0.26} stopColor="#f2831f" />
          <stop offset={0.48} stopColor="#f48d1b" />
          <stop offset={0.68} stopColor="#f79e15" />
          <stop offset={0.87} stopColor="#fbb60c" />
          <stop offset={1} stopColor="#ffcb05" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-17"
          x1={-604.26}
          y1={-122.42}
          x2={-591.32}
          y2={-135.35}
          gradientTransform="translate(-106.28 -582.12) rotate(-90) scale(1 -1)"
          xlinkHref="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-18"
          x1={-525.78}
          y1={-55.7}
          x2={-535.12}
          y2={-69.54}
          gradientTransform="translate(547.72 71.88)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.3} stopColor="#010101" />
          <stop offset={1} stopColor="#010101" />
        </linearGradient>
      </defs>
      <g className="cls-27">
        <g id="Layer_1" data-name="Layer 1">
          <rect
            className="cls-7"
            x={-1.88}
            y={-2.32}
            width={143.12}
            height={42.53}
            fill={"transparent"}
          />
          <g>
            <path
              className="cls-3"
              d="m79.03,14.86l-2.17-8.38h-2.2c-.32.02-.59.14-.81.37-.22.22-.33.49-.33.81v9.81h2.1v-8.86l2.26,8.86h2.33l2.23-8.86v8.86h2.1V6.48h-3.35l-2.17,8.38Zm13.05-5.86c-.55,0-.89.25-1.02.76l-1.5,5.23-1.72-5.99h-2.45l2.96,8.44c.15.45.1.77-.14.97-.24.2-.58.3-1,.3h-.61v1.75c.06,0,.14,0,.24.02.1.01.18.03.24.05h.45c.87,0,1.5-.13,1.88-.38.38-.3.7-.8.96-1.5l3.25-9.65h-1.53Z"
            />
            <g className="cls-28">
              <path
                className="cls-16"
                d="m91.06,9.79l-1.3,4.54c.7-.01,1.39-.02,2.08-.04l1.77-5.27h-1.53c-.55,0-.89.25-1.02.76Z"
              />
              <path
                className="cls-18"
                d="m87.84,9.03h-2.45l1.87,5.33c.71,0,1.41-.01,2.11-.02l-1.53-5.31Z"
              />
              <path
                className="cls-25"
                d="m122.93,9.98c-.7-.76-1.69-1.15-2.96-1.15s-2.16.39-2.84,1.18c-.56.65-.88,1.52-.96,2.59.76-.09,1.51-.19,2.24-.3.03-.51.19-.9.47-1.18.3-.3.68-.45,1.15-.45.51,0,.9.15,1.18.45.16.18.28.41.36.71.73-.12,1.45-.24,2.15-.36-.17-.58-.43-1.08-.79-1.49Z"
              />
              <path
                className="cls-10"
                d="m129.81,8.84l-.95,1.6c1.01-.23,1.97-.47,2.87-.72l.94-1.45h-1.91c-.45,0-.76.19-.96.57Z"
              />
              <path
                className="cls-5"
                d="m109.98,13.28s0-.05,0-.08c0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.24.02.47.04.7.73-.04,1.45-.09,2.16-.14-.01-.13-.02-.27-.03-.42-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72,0,.08,0,.16-.01.24.73-.06,1.46-.12,2.17-.19Z"
              />
              <path
                className="cls-17"
                d="m115.67,11.29v-2.26h-.32c-.57,0-1.13.07-1.67.22-.54.15-1.01.38-1.42.7-.43.34-.76.79-1,1.35-.22.52-.34,1.15-.36,1.89.75-.07,1.5-.15,2.23-.23.03-.55.17-.96.44-1.23.3-.3.75-.45,1.37-.45h.73Z"
              />
              <path
                className="cls-22"
                d="m102.35,8.42v-1.88h-6.82c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v6.54c.75-.02,1.49-.05,2.23-.08v-1.49h3.12c.32,0,.59-.11.81-.33.22-.22.33-.49.33-.81v-.73h-4.27v-2.36h5.74Z"
              />
              <path
                className="cls-19"
                d="m126.72,9.03h-2.45l1.33,2.1c.71-.14,1.41-.28,2.08-.43l-.96-1.67Z"
              />
              <path
                className="cls-24"
                d="m67.01,6.86c-.21-.21-.47-.32-.76-.32h-1.15v7.1c1.82.13,3.69.25,5.59.35l-1-1.71,3.03-3.25h-2.68l-2.71,3.12v-4.56c0-.28-.11-.52-.32-.73Z"
              />
              <path
                className="cls-9"
                d="m55.09,10.75c-.38-.79-.98-1.34-1.78-1.66-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.02.07-.03.13-.05.2.69.12,1.39.23,2.11.34.1-.34.26-.63.47-.86.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.15.24.26.55.32.94.72.1,1.46.19,2.2.28-.05-.74-.22-1.4-.52-1.99Z"
              />
              <path
                className="cls-1"
                d="m46.36,10.72c.23-.38.35-.85.35-1.4,0-.87-.3-1.56-.89-2.07-.6-.47-1.46-.7-2.58-.7h-4.01c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v1.76c.69.2,1.41.4,2.17.59v-1.58h2.55c.62,0,1.03.08,1.24.25.26.19.38.49.38.89s-.13.7-.38.89c-.17.13-.42.21-.73.26.82.18,1.68.35,2.56.51.2-.16.37-.34.5-.55Z"
              />
              <path
                className="cls-12"
                d="m79.18,14.3c.61.01,1.21.02,1.82.03l1.43-5.69v5.71c.7,0,1.4.01,2.1.01v-7.85h-3.35l-2.01,7.79Z"
              />
              <path
                className="cls-15"
                d="m76.86,6.51h-2.2c-.32.02-.59.14-.81.37-.22.22-.33.49-.33.81v6.43c.7.03,1.4.05,2.1.08v-5.56l1.43,5.6c.6.02,1.21.03,1.82.05l-2.01-7.78Z"
              />
              <path
                className="cls-8"
                d="m64.11,13.57c0-.12.01-.24.01-.37,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.14,1.13-.34.38-.59.86-.75,1.43-.13.46-.2.91-.23,1.37.71.08,1.42.16,2.15.24,0-.84.2-1.48.61-1.92.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72,0,.05,0,.1,0,.15.71.06,1.43.12,2.16.18Z"
              />
            </g>
            <g>
              <path
                className="cls-23"
                d="m115.06,24.89c-.46,0-.77-.33-.77-.78,0-.52.38-.97.94-.97.46,0,.78.32.78.81,0,.56-.4.95-.95.95h0Z"
              />
              <path
                className="cls-23"
                d="m119.65,24.69c-.28.14-.69.21-1.15.21-.99,0-1.78-.58-1.78-1.73,0-1.47,1.14-2.55,2.74-2.55.33,0,.61.05.82.12l-.33,1.07c-.13-.05-.28-.07-.49-.07-.77,0-1.25.59-1.25,1.27,0,.52.37.75.72.75.32,0,.54-.07.75-.15l-.02,1.07Z"
              />
              <path
                className="cls-23"
                d="m124.6,22.3c0,1.59-1.08,2.59-2.51,2.59-1.05,0-1.8-.64-1.8-1.7,0-1.44,1.02-2.58,2.52-2.58,1.1,0,1.79.72,1.79,1.68Zm-2.84.87c0,.4.18.65.52.65.58,0,.85-.92.85-1.51,0-.34-.14-.62-.52-.62-.61,0-.86.98-.86,1.48Z"
              />
              <path
                className="cls-23"
                d="m124.91,24.81l.5-2.7c.1-.54.17-1.01.22-1.39h1.21l-.06.62h0c.37-.52.86-.72,1.38-.72.67,0,.94.42.97.72.37-.5.88-.72,1.37-.72.7,0,1,.45,1,1.11,0,.17-.03.51-.07.71l-.44,2.37h-1.37l.4-2.19c.03-.16.06-.32.06-.47,0-.22-.11-.39-.32-.39-.36,0-.67.52-.82,1.31l-.32,1.75h-1.36l.41-2.19c.02-.16.05-.32.05-.45,0-.25-.08-.42-.29-.42-.36,0-.7.52-.84,1.31l-.32,1.75h-1.37Z"
              />
            </g>
            <path
              className="cls-11"
              d="m45.38,11.54c.42-.21.75-.5.99-.86.23-.38.35-.85.35-1.4,0-.87-.3-1.56-.89-2.07-.6-.47-1.46-.7-2.58-.7h-4.01c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v9.81h5c1.27,0,2.26-.29,2.96-.86.68-.59,1.02-1.42,1.02-2.49,0-.66-.14-1.19-.41-1.59-.3-.42-.72-.75-1.27-.99Zm-5.13-3.12h2.55c.62,0,1.03.08,1.24.25.25.19.38.49.38.89s-.13.7-.38.89c-.26.19-.66.29-1.21.29h-2.58v-2.33Zm4.05,6.72c-.32.23-.78.35-1.37.35h-2.68v-2.87h2.64c.66,0,1.13.11,1.4.32.3.23.45.61.45,1.12s-.15.87-.45,1.08Zm9.01-6.09c-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.7.1,1.38.29,2.02.19.65.51,1.16.96,1.55.42.38.99.65,1.7.81.71.16,1.42.14,2.12-.05.79-.17,1.43-.61,1.94-1.31.23-.34.42-.75.57-1.24.15-.49.22-1.07.22-1.75,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66Zm-.25,5.99c-.25.38-.55.62-.88.72-.33.1-.65.09-.97-.03-.32-.12-.54-.26-.67-.43-.32-.38-.5-1.06-.54-2.02-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72-.02.85-.16,1.47-.41,1.85Zm8.74-5.99c-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.7.1,1.38.29,2.02.19.65.51,1.16.96,1.55.42.38.99.65,1.7.81.71.16,1.42.14,2.12-.05.79-.17,1.43-.61,1.94-1.31.23-.34.43-.75.57-1.24.15-.49.22-1.07.22-1.75,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66Zm-.25,5.99c-.26.38-.55.62-.88.72-.33.1-.65.09-.97-.03-.32-.12-.54-.26-.67-.43-.32-.38-.5-1.06-.54-2.02-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72-.02.85-.16,1.47-.41,1.85Zm11.17-6.05h-2.68l-2.71,3.12v-4.56c0-.28-.11-.52-.32-.73-.21-.21-.47-.32-.76-.32h-1.15v10.96h2.23v-3.22c0-.17.12-.3.35-.38.23-.08.51.16.83.73l1.56,2.87h2.68l-3.06-5.23,3.03-3.25Zm23.9-.61h5.74v-1.88h-6.82c-.32,0-.59.11-.81.33-.22.22-.33.49-.33.81v9.81h2.23v-4.84h3.12c.32,0,.59-.11.81-.33.22-.22.33-.49.33-.81v-.73h-4.27v-2.36Zm11.04.67c-.7-.25-1.49-.32-2.36-.21-.87.12-1.58.49-2.13,1.13-.34.38-.59.86-.75,1.43-.16.57-.24,1.15-.24,1.72,0,.7.1,1.38.29,2.02.19.65.51,1.16.96,1.55.42.38.99.65,1.7.81.71.16,1.42.14,2.12-.05.79-.17,1.43-.61,1.94-1.31.23-.34.42-.75.57-1.24.15-.49.22-1.07.22-1.75,0-.93-.18-1.75-.54-2.45-.38-.79-.98-1.34-1.78-1.66Zm-.26,5.99c-.25.38-.55.62-.88.72-.33.1-.65.09-.97-.03-.32-.12-.54-.26-.67-.43-.32-.38-.5-1.06-.54-2.02-.04-.97.16-1.69.61-2.18.15-.15.38-.27.7-.37.32-.1.64-.09.96.02.32.11.6.35.84.73.24.38.37.96.37,1.72-.02.85-.16,1.47-.41,1.85Zm6.28-5.83c-.54.15-1.01.38-1.42.7-.43.34-.76.79-1,1.35-.24.56-.37,1.26-.37,2.09v4.11h2.23v-4.36c0-.64.15-1.1.45-1.4.3-.3.75-.45,1.37-.45h.73v-2.26h-.32c-.57,0-1.13.07-1.67.22Zm6.28-.41c-1.21,0-2.16.39-2.84,1.18-.66.76-.99,1.83-.99,3.19s.34,2.52,1.02,3.28c.68.79,1.62,1.18,2.84,1.18,1,0,1.83-.24,2.48-.73.66-.47,1.1-1.15,1.34-2.04h-1.59c-.26,0-.45.05-.59.16-.14.11-.22.19-.24.26-.06.06-.12.12-.18.18-.05.05-.11.09-.18.11-.25.15-.56.22-.92.22-.55,0-.97-.17-1.24-.51-.3-.32-.46-.81-.48-1.47h5.51s.03-.12.03-.22v-.35c0-1.4-.34-2.5-1.02-3.28-.7-.76-1.69-1.15-2.96-1.15Zm-1.56,3.57c.02-.55.18-.98.48-1.27.3-.3.68-.45,1.15-.45.51,0,.9.15,1.18.45.25.28.4.7.45,1.27h-3.25Zm14.28-4.14h-1.91c-.45,0-.76.19-.96.57l-1.62,2.74-1.47-2.55h-2.45l2.61,4.11-2.77,4.36h2.58l1.56-2.68,1.5,2.68h2.55l-2.8-4.33,3.19-4.91Z"
            />
            <path
              className="cls-6"
              d="m26.34,3.01h-2.21l4.55,4.55v-2.21c0-1.29-1.05-2.34-2.34-2.34Zm-16.36,2.34v2.21l4.55-4.55h-2.21c-1.29,0-2.34,1.05-2.34,2.34Zm0,14.03c0,1.29,1.05,2.34,2.34,2.34h2.21l-4.54-4.55v2.21Zm16.36,2.34c1.29,0,2.34-1.05,2.34-2.34v-2.21l-4.55,4.55h2.21Z"
            />
            <path
              className="cls-13"
              d="m10.36,16.36l-2.52-2.54s-1.2-1.37.05-2.97L17.7,1.04s1.19-1.34,3-.21l5.71,5.71-3.52,1.32.52.49-3.59,3.59-1.16-1.08-6.89,6.91-1.4-1.4Z"
            />
            <path
              className="cls-2"
              d="m15.33,21.33l2.54,2.52s1.37,1.2,2.97-.05l9.81-9.81s1.34-1.19.21-3l-4.38-4.38-1.25,3.36-.55-.49-4.85,4.82-1.1-1.11-5.78,5.77,2.37,2.37Z"
            />
            <path
              className="cls-20"
              d="m16.46,13.03l2.19-2.19,1.17,1.09,3.59-3.61-.52-.48,3.52-1.32L20.7.83c-.45-.26-.8-.43-1.38-.45-.48-.02-1.07.16-1.54.58L7.89,10.85c-.76.95-.73,2.13-.05,2.97l3.92,3.94,4.7-4.73ZM12.3,3.01c-1.29,0-2.34,1.05-2.34,2.34v2.21l4.55-4.55h-2.21Zm12.93,6.96l-.55-.49-4.85,4.81-1.09-1.11-2.15,2.15-3.63,3.62.34.34c7.47-.8,13.36-5.56,14.28-11.59l-1.09-1.09-1.26,3.36Zm-15.27,9.4s0,0,0,0c.37.02.74.03,1.12.03s.73-.01,1.09-.03l-2.21-2.22v2.21ZM27.35,3.24c-.31-.15-.65-.23-1.02-.23h-2.21l3.57,3.57c0-.18.02-.37.02-.55,0-.96-.13-1.89-.36-2.79Z"
            />
            <path
              className="cls-21"
              d="m33.19,32.78c-.21,0-.37-.08-.49-.22-.12-.15-.18-.36-.18-.63,0-.3.05-.57.15-.83s.24-.46.42-.61c.18-.15.37-.22.59-.22.14,0,.26.03.37.1.1.07.18.16.24.29h.02l.14-.35h.39l-.52,2.42h-.4l.05-.39h-.01c-.23.29-.49.43-.76.43Zm.19-.42c.12,0,.24-.06.35-.17.11-.11.21-.26.29-.45s.11-.4.11-.62c0-.13-.03-.23-.1-.31-.07-.08-.16-.12-.27-.12-.12,0-.24.06-.35.17s-.2.27-.26.46-.1.39-.1.6c0,.15.03.26.09.33.06.07.14.11.25.11Z"
            />
            <g>
              <path
                className="cls-21"
                d="m87.85,29.87l-.07.3-.42.07c.04.09.06.18.06.3,0,.28-.09.51-.26.67-.17.16-.41.25-.7.25-.08,0-.14,0-.2-.02-.16.06-.24.14-.24.23,0,.06.02.09.07.11.05.02.11.04.2.05l.28.03c.26.03.44.1.55.19.11.1.17.23.17.41,0,.29-.11.51-.33.66-.22.15-.53.23-.94.23-.3,0-.53-.05-.69-.16-.16-.11-.24-.26-.24-.45,0-.15.05-.28.15-.39.1-.11.26-.2.49-.28-.11-.07-.17-.16-.17-.28,0-.1.03-.19.1-.26s.17-.14.32-.21c-.2-.12-.3-.3-.3-.55,0-.29.09-.52.27-.69.18-.17.42-.26.71-.26.12,0,.23.02.35.04h.84Zm-1.79,2.38c-.16.03-.29.08-.38.15-.09.08-.13.17-.13.29,0,.09.04.17.12.23.08.06.21.09.37.09.24,0,.42-.04.56-.12.13-.08.2-.19.2-.34,0-.08-.03-.13-.1-.18s-.18-.07-.35-.09l-.3-.03Zm.59-2.09c-.09,0-.18.03-.25.09-.07.06-.13.13-.17.23s-.06.2-.06.32c0,.1.03.18.08.24.05.06.13.09.22.09s.18-.03.25-.09c.07-.06.12-.14.16-.24.04-.1.06-.21.06-.33,0-.21-.1-.31-.29-.31Z"
              />
              <path
                className="cls-21"
                d="m89.43,29.83c.09,0,.17,0,.24.03l-.11.48c-.08-.02-.15-.03-.22-.03-.18,0-.35.08-.49.25-.14.17-.25.38-.3.65l-.23,1.1h-.52l.52-2.42h.4l-.05.45h.02c.12-.17.24-.3.36-.38.12-.08.25-.12.39-.12Z"
              />
              <path
                className="cls-21"
                d="m91.88,30.78c0,.3-.05.56-.16.81-.11.24-.25.43-.44.56-.19.13-.4.19-.64.19-.28,0-.5-.08-.67-.25-.16-.17-.25-.4-.25-.68s.05-.56.16-.8c.1-.24.25-.43.44-.57s.41-.2.65-.2c.29,0,.51.08.67.25.16.17.24.4.24.69Zm-.52-.02c0-.16-.04-.28-.11-.37s-.17-.13-.31-.13-.26.05-.37.16-.19.25-.25.43c-.06.18-.09.37-.09.57,0,.16.04.29.11.37.07.09.18.13.32.13.13,0,.25-.05.36-.15.11-.1.19-.24.25-.42.06-.18.09-.38.09-.59Z"
              />
              <path
                className="cls-21"
                d="m93.2,29.87l-.28,1.34c-.05.2-.07.35-.07.42,0,.2.09.29.28.29.1,0,.21-.04.31-.12s.2-.2.28-.36c.08-.15.14-.33.19-.54l.22-1.03h.51l-.51,2.42h-.41l.05-.45h-.02c-.12.17-.24.29-.37.37-.13.08-.27.12-.42.12-.2,0-.35-.06-.45-.17-.11-.11-.16-.27-.16-.48,0-.09,0-.18.03-.27.02-.09.03-.18.05-.27l.27-1.28h.52Z"
              />
              <path
                className="cls-21"
                d="m96,32.34c-.26,0-.46-.13-.59-.39h-.02c-.01.14-.03.28-.06.41l-.21,1.01h-.51l.74-3.5h.4l-.05.41h.02c.23-.3.48-.46.75-.46.21,0,.37.08.49.23.12.15.18.36.18.63,0,.3-.05.58-.15.84s-.24.46-.42.6c-.18.14-.37.22-.58.22Zm.29-2.09c-.12,0-.24.06-.35.17s-.21.27-.29.46c-.07.19-.11.39-.11.59,0,.14.03.25.1.33.07.08.16.12.29.12s.24-.06.35-.17c.11-.11.19-.27.26-.46.06-.19.09-.39.09-.6,0-.29-.11-.44-.34-.44Z"
              />
              <path
                className="cls-21"
                d="m99.64,32.34c-.29,0-.51-.08-.67-.23-.16-.15-.24-.37-.24-.66,0-.3.05-.58.16-.83s.26-.44.45-.58c.19-.14.41-.21.66-.21s.46.04.65.13l-.15.4c-.18-.08-.34-.12-.48-.12-.22,0-.4.11-.55.34-.15.22-.22.5-.22.83,0,.16.04.29.12.37.08.09.2.13.34.13.11,0,.21-.02.3-.05.09-.03.19-.07.28-.12v.43c-.2.1-.43.16-.67.16Z"
              />
              <path
                className="cls-21"
                d="m102.99,30.78c0,.3-.05.56-.16.81-.11.24-.25.43-.44.56-.19.13-.4.19-.64.19-.28,0-.5-.08-.67-.25-.16-.17-.25-.4-.25-.68s.05-.56.16-.8c.1-.24.25-.43.44-.57s.41-.2.65-.2c.29,0,.51.08.67.25.16.17.24.4.24.69Zm-.52-.02c0-.16-.04-.28-.11-.37s-.17-.13-.31-.13-.26.05-.37.16-.19.25-.25.43c-.06.18-.09.37-.09.57,0,.16.04.29.11.37.07.09.18.13.32.13.13,0,.25-.05.36-.15.11-.1.19-.24.25-.42.06-.18.09-.38.09-.59Z"
              />
              <path
                className="cls-21"
                d="m104.96,29.83c.32,0,.51.17.56.52h.02c.11-.17.23-.3.37-.38.14-.09.28-.13.43-.13.19,0,.34.06.44.17s.15.27.15.47c0,.09-.02.23-.05.4l-.31,1.43h-.51l.31-1.47c.03-.14.04-.24.04-.29,0-.19-.09-.28-.27-.28-.16,0-.3.09-.44.27-.14.18-.24.42-.3.72l-.22,1.05h-.51l.31-1.47c.03-.12.04-.21.04-.28,0-.2-.09-.3-.26-.3s-.31.09-.45.28-.24.43-.3.74l-.21,1.03h-.52l.52-2.42h.4l-.05.45h.02c.22-.33.47-.49.77-.49Z"
              />
              <path
                className="cls-21"
                d="m108.45,32.34c-.26,0-.46-.13-.59-.39h-.02c-.01.14-.03.28-.06.41l-.21,1.01h-.51l.74-3.5h.4l-.05.41h.02c.23-.3.48-.46.75-.46.21,0,.37.08.49.23.12.15.18.36.18.63,0,.3-.05.58-.15.84s-.24.46-.42.6c-.18.14-.37.22-.58.22Zm.29-2.09c-.12,0-.24.06-.35.17s-.21.27-.29.46c-.07.19-.11.39-.11.59,0,.14.03.25.1.33.07.08.16.12.29.12s.24-.06.35-.17c.11-.11.19-.27.26-.46.06-.19.09-.39.09-.6,0-.29-.11-.44-.34-.44Z"
              />
              <path
                className="cls-21"
                d="m110.69,32.34c-.21,0-.37-.08-.49-.22-.12-.15-.18-.36-.18-.63,0-.3.05-.57.15-.83s.24-.46.42-.61c.18-.15.37-.22.59-.22.14,0,.26.03.37.1.1.07.18.16.24.29h.02l.14-.35h.39l-.52,2.42h-.4l.05-.39h-.01c-.23.29-.49.43-.76.43Zm.19-.42c.12,0,.24-.06.35-.17.11-.11.21-.26.29-.45s.11-.4.11-.62c0-.13-.03-.23-.1-.31-.07-.08-.16-.12-.27-.12-.12,0-.24.06-.35.17s-.2.27-.26.46-.1.39-.1.6c0,.15.03.26.09.33.06.07.14.11.25.11Z"
              />
              <path
                className="cls-21"
                d="m113.95,32.3l.31-1.47c.03-.13.04-.23.04-.29,0-.19-.09-.29-.28-.29-.11,0-.21.04-.31.13s-.19.2-.28.36c-.08.16-.14.33-.18.53l-.21,1.03h-.52l.52-2.42h.4l-.05.45h.02c.12-.17.25-.3.37-.37.13-.08.27-.12.42-.12.2,0,.35.06.45.17.11.11.16.27.16.47,0,.1-.02.23-.05.4l-.3,1.43h-.52Z"
              />
              <path
                className="cls-21"
                d="m115.28,29.87h.51l.14,1.16c.01.09.02.22.03.38s.02.3.02.4h.01c.13-.31.22-.54.3-.69l.64-1.26h.56l-1.51,2.8c-.13.24-.27.42-.43.53-.15.11-.34.17-.54.17-.11,0-.22-.01-.31-.04v-.41c.11.02.2.03.27.03.11,0,.21-.03.29-.09s.18-.18.27-.34l.11-.2-.36-2.44Z"
              />
            </g>
            <g>
              <path
                className="cls-4"
                d="m67.43,38.63c.86-.01,1.68-.35,2.28-.95.61-.61.94-1.43.94-2.28v-7.8c0-.86-.34-1.68-.93-2.3-.61-.61-1.43-.95-2.29-.95h-7.85c-.86.01-1.68.35-2.28.95-.61.62-.94,1.44-.94,2.3v7.81c.01,1.77,1.45,3.21,3.22,3.22"
              />
              <path
                className="cls-14"
                d="m65.2,31.93c-.3,1.01.19,2.02,1.23,1.62-.3.73-.81,1.82-.81,2.95,0,0,0,.76.56.95,0,0,.79.19.62-.51-.12-.44-.16-.89-.1-1.34.19-.93.48-1.84.86-2.72,0,0,1.2-2.5,1.9-3.67,0,0,.29-.59-.3-.59-.18,0-.35.09-.46.24l-1.69,3.02c-.26.47-.51.62-.7.62-.43,0-.34-.68-.27-.93.19-.84.49-1.65.9-2.42.3-.66-.3-.72-.3-.72-.38-.1-.67.53-.67.53l-.67,1.37c-.44.76-.92,1.49-1.44,2.2,0,0-.09.11-.16.07-.07-.06-.03-.17-.03-.17.11-.93.3-1.85.56-2.76.01-.06.02-.1.02-.16.01-.12-.02-.25-.1-.34-.08-.1-.19-.16-.31-.16-.3-.03-.45.11-.72.44-.59.73-1.29,1.83-1.63,2.32-.03.06-.1.04-.1-.03,0-.22.79-2.65.79-2.65,0,0,.09-.34-.18-.45,0,0-.42-.26-.75.25l-1.62,2.2c-.12.17-.19.11-.19.11v-.15l.26-1.44c.2-1.1-.18-1.16-.43-1.2-.18,0-.37.06-.53.16-.51.25-.89,1.25-.89,1.25,0,0-.11.36.13.51.08.04.17.08.26.07.36-.02.43-.68.68-.68.04,0,.04.06.04.07l-.83,3.49c-.06.2.03.42.2.53.11.07.24.08.36.06.11-.03.21-.11.28-.21l.3-.47c.44-.77,1.25-1.89,1.32-1.89.03,0,.04,0,.04.03l-.3,2.05c-.03.18.07.37.24.45.16.06.33.04.47-.03.17-.13.31-.3.42-.49.17-.27.98-1.22,1.47-2.1.03-.06.07,0,.06.03-.1.46-.18,1.68-.19,1.99-.02.59.44.66.45.66.3.02.59-.11.76-.36"
              />
              <path
                className="cls-26"
                d="m41.05,33.28h-.9v-2.01c.01-.22-.03-.45-.13-.64-.1-.15-.28-.24-.46-.21-.16,0-.3.03-.43.11-.13.09-.25.21-.33.35v2.4h-.9v-3.65h.51l.34.49c.09-.08.18-.15.27-.21.09-.06.18-.1.28-.15.1-.04.2-.08.3-.1.1-.02.21-.03.33-.03.12,0,.25.01.36.04.09.03.18.07.27.12.07.06.13.12.19.19.07.09.11.17.16.26.07-.07.15-.15.24-.21.09-.07.19-.13.3-.19.1-.07.21-.12.34-.17.13-.03.27-.06.42-.06.18,0,.35.04.51.12.15.09.27.2.35.34.09.17.16.34.19.53.04.21.07.43.07.65v2.02h-.91v-2.01c.02-.22-.02-.45-.13-.64-.1-.15-.27-.24-.45-.21-.15,0-.29.03-.43.11-.13.09-.26.2-.34.35"
              />
              <path
                className="cls-26"
                d="m46.23,31.62h-.8c-.17-.01-.33.03-.47.12-.09.09-.15.21-.15.35,0,.12.04.24.13.33.1.08.24.12.37.11.1,0,.2-.01.3-.04.09-.02.18-.06.26-.1.08-.06.15-.11.2-.17.07-.07.11-.13.16-.2m-.01.86c-.12.12-.28.22-.44.29-.21.08-.44.12-.66.11-.16.01-.33-.02-.47-.08-.13-.06-.26-.13-.37-.24-.1-.11-.18-.24-.24-.37-.06-.15-.08-.3-.08-.46,0-.67.53-1.11,1.37-1.11h.9v-.2c0-.13-.08-.25-.19-.3-.18-.08-.38-.12-.58-.11-.22,0-.45.03-.66.08-.17.04-.34.1-.51.17l-.1-.75c.06-.03.13-.06.24-.09.09-.03.2-.06.3-.09.1-.02.24-.04.37-.07.13-.02.28-.02.43-.02.42-.03.84.1,1.16.37.28.29.42.68.39,1.08v2.2h-.64l-.21-.4Z"
              />
              <polyline
                className="cls-26"
                points="51.3 29.58 49.85 31.4 51.5 33.27 50.37 33.27 48.85 31.42 48.85 33.27 47.96 33.27 47.96 28.28 48.85 28.28 48.85 31.42 50.21 29.58 51.3 29.58"
              />
              <path
                className="cls-26"
                d="m53.28,30.44c-.11,0-.22.01-.33.04-.09.02-.18.07-.25.12-.08.04-.13.11-.18.19-.04.08-.08.16-.1.25h1.58c0-.08-.01-.16-.04-.24-.02-.07-.08-.13-.13-.19-.07-.06-.15-.1-.22-.13-.11-.03-.22-.06-.33-.04m.17,2.05c.13,0,.28-.01.42-.04.12-.02.25-.06.36-.1.1-.03.2-.08.29-.13.04-.02.09-.06.13-.09l.17.8c-.19.1-.39.19-.61.26-.25.07-.51.1-.76.1-.28,0-.56-.04-.83-.13-.21-.08-.43-.2-.59-.37-.17-.16-.29-.36-.37-.57-.1-.22-.15-.47-.16-.73,0-.24.03-.47.11-.7.08-.22.19-.42.35-.59.15-.17.34-.3.55-.39.48-.19,1.03-.19,1.52,0,.2.08.37.21.52.37.13.16.24.34.3.53.06.2.09.42.09.63v.19c-.01.07-.02.13-.03.19h-2.48c.01.12.04.24.1.34.04.1.12.19.21.26.09.08.19.13.31.16.12.04.26.07.4.07v-.02h0Z"
              />
              <path
                className="cls-26"
                d="m71.52,30.15l1.19-1.44h.27v.91h1.02v.79h-1.02v1.5c0,.08.01.17.03.26.02.06.06.11.1.17.04.03.1.07.16.08.06.02.11.03.18.03.1,0,.2-.01.29-.04.09-.01.17-.04.25-.08v.8c-.09.04-.19.08-.3.1-.31.07-.64.06-.94-.03-.15-.04-.27-.12-.38-.22-.09-.1-.17-.22-.21-.36-.04-.15-.08-.31-.07-.47v-1.71h-.58"
              />
              <path
                className="cls-26"
                d="m75.53,30.39c.13-.22.3-.42.52-.56.18-.13.4-.2.64-.19.07-.01.13-.01.2,0l.12.02s-.02.2-.16.83c-.07-.01-.13-.02-.2-.01-.16-.01-.3.02-.45.08-.13.06-.25.15-.34.26-.09.11-.17.25-.21.39-.04.18-.07.36-.07.54v1.54h-.9v-3.65h.56"
              />
              <path
                className="cls-26"
                d="m81.04,30.43c-.1-.01-.2.01-.29.04-.09.03-.17.08-.25.13-.07.04-.12.11-.18.18-.04.07-.09.13-.11.21v1.03c.03.07.08.12.13.18.06.06.11.1.18.15.08.04.16.08.24.1.22.06.46.04.67-.03.1-.06.2-.12.27-.21.08-.09.13-.2.17-.31.03-.13.06-.28.07-.43,0-.13-.02-.28-.07-.43-.03-.12-.09-.24-.17-.34-.08-.09-.17-.17-.28-.21-.11-.06-.22-.08-.35-.08m.21-.79c.25-.01.48.04.7.15.19.1.35.24.48.42.12.18.22.38.28.59.06.22.09.46.09.68,0,.24-.03.47-.1.7-.06.21-.16.4-.29.57-.13.17-.29.3-.48.39-.2.1-.44.15-.66.15s-.44-.03-.64-.11c-.17-.08-.33-.18-.45-.33v1.9h-.9v-5.11h.53l.35.44c.13-.13.3-.25.49-.34.19-.07.39-.11.6-.1h.01Z"
              />
              <path
                className="cls-26"
                d="m77.93,28.14c-.26,0-.46.2-.46.46s.2.47.46.47.46-.21.46-.47c.01-.12-.04-.24-.13-.33-.08-.09-.2-.15-.33-.15m.44,5.15h-.9v-3.65h.9v3.65Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default BMFLogo;
